<div class="toggle-icon" appToggleIcon [defaultState]="defaultState"  (stateChange)="changedicon($event)">
  @for (icon of icons; track icon) {
    <label for="" aria-label="icon"><i class="{{icon}}"></i></label>
  }
</div>
